import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Card } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

//API
import tipoDeFiscalizacao_api from '../../../../api/tipoDeFIscalizacao_api';
import relatorio_api from '../../../../api/relatorio_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';
import {
    COM_INFRACAO,
    initialStateConsultaGerenciamentoFiscalizacao,
    montarFiltroApi,
    opcoesInfracao,
    opcoesTipoBusca,
    validarFiltroGerenciamentoFiscalizacao
} from '../../GerenciamentoDeFiscalizacao/helpers/gerenciamentoFiscalizacao';

//Components
import TextField from '../../../../components/TextField';
import RelatorioGerenciamentoFiscalizacao from './RelatorioGerenciamentoFiscalizacao';

//Context
import { useAuth } from '../../../../context/auth';

export default function GerenciamentoFiscalizacao() {
    //State do filtro do relatório
    const [filtro, setFiltro] = useState(initialStateConsultaGerenciamentoFiscalizacao());

    //State com a lista dos tipos de fiscalização
    const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

    //State com o resultado do relatório (infrações ou fiscalizações sem infração)
    const [itens, setItens] = useState([]);

    //Filtros usados na consulta que gerou o relatório exibido
    const [filtrosRelatorio, setFiltrosRelatorio] = useState(null);

    const { setLoading } = useAuth();

    const navigate = useNavigate();

    const loadTipoDeFiscalizacao = () => {
        setLoading(true);
        tipoDeFiscalizacao_api.getList()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                setListTipoDeFiscalizacao([{ value: "0", label: "Todos" }, ...response.data])
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setFiltro({ ...filtro, [name]: value });
    };

    const onChangeSelect = (value, e) => {
        setFiltro({ ...filtro, [e.name]: value ? value.value.toString() : null });
    };

    const handleGerarRelatorio = () => {
        const mensagem = validarFiltroGerenciamentoFiscalizacao(filtro);

        if (mensagem)
            return showMessage("Aviso", mensagem, "warning", null);

        //Descrição resolvida na hora da consulta para o cabeçalho do relatório
        const filtrosConsulta = {
            ...filtro,
            tipoFiscalizacao_Descricao: listTipoDeFiscalizacao.filter(value => value.value == filtro.tipoFiscalizacao_Id)[0]?.label ?? "Todos"
        };

        //O relatório acompanha o filtro Infração da tela: Com Infração traz o
        //histórico dos autos, Sem Infração traz as fiscalizações sem auto.
        const consultar = filtro.infracao === COM_INFRACAO
            ? relatorio_api.RelatorioGerenciamentoFiscalizacao(montarFiltroApi(filtro))
            : relatorio_api.RelatorioGerenciamentoFiscalizacaoSemInfracao(montarFiltroApi(filtro));

        setLoading(true);
        consultar
            .then(response => {
                const dados = (response.data ?? []).map(value => {
                    value.documentoInfrator = mascaras.cpfcnpjMask(value.documentoInfrator);
                    return value;
                });

                if (dados.length === 0)
                    return showMessage("Aviso", "Nenhum registro encontrado para os filtros informados.", "warning", null);

                setFiltrosRelatorio(filtrosConsulta);
                setItens(dados);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    const handleVoltar = () => {
        setItens([]);
    };

    useEffect(() => {
        loadTipoDeFiscalizacao();
    }, []);

    if (itens.length > 0) {
        return <RelatorioGerenciamentoFiscalizacao
            handleVoltar={handleVoltar}
            itens={itens}
            filtros={filtrosRelatorio ?? filtro}
        />
    }

    return <Card className='shadowFicha mainContainerFicha p-4'>
        <div className='mb-3'>
            <Button color='secondary' className='text-white' onClick={() => navigate(-1)}>
                <FontAwesomeIcon icon={faArrowLeft} />
                <span className='px-2'> Voltar </span>
            </Button>
        </div>
        <h4 className='text-secondary m-0'>Gerenciamento de Fiscalização</h4>
        <Row className='mt-3'>
            <Col md={12} lg={3}>
                <TextField
                    type={"select"}
                    name={"tipoBusca"}
                    label={"* Tipo de Busca"}
                    searchable
                    options={opcoesTipoBusca}
                    onChange={onChangeSelect}
                    value={opcoesTipoBusca.filter(value => value.value == filtro.tipoBusca)}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"select"}
                    name={"infracao"}
                    label={"* Infração"}
                    searchable
                    options={opcoesInfracao}
                    onChange={onChangeSelect}
                    value={opcoesInfracao.filter(value => value.value == filtro.infracao)}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"date"}
                    name={"dataInicial"}
                    label={"Data Inicial"}
                    onChange={onChange}
                    value={filtro.dataInicial}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"date"}
                    name={"dataFinal"}
                    label={"Data Final"}
                    onChange={onChange}
                    value={filtro.dataFinal}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"select"}
                    name={"tipoFiscalizacao_Id"}
                    label={"Tipo de Fiscalização"}
                    searchable
                    options={listTipoDeFiscalizacao}
                    onChange={onChangeSelect}
                    value={listTipoDeFiscalizacao.filter(value => value.value == filtro.tipoFiscalizacao_Id)}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"text"}
                    name={"numeroInfracao"}
                    label={"Número da infração"}
                    onChange={onChange}
                    value={filtro.numeroInfracao}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"text"}
                    name={"documentoIdentificacao"}
                    label={"CPF/CNPJ do Infrator"}
                    mask={mascaras.cpfcnpjMask}
                    onChange={onChange}
                    value={filtro.documentoIdentificacao}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"text"}
                    name={"nome"}
                    label={"Nome/Razão Social do Infrator"}
                    onChange={onChange}
                    value={filtro.nome}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"text"}
                    name={"logradouro"}
                    label={"Logradouro"}
                    onChange={onChange}
                    value={filtro.logradouro}
                />
            </Col>
            <Col md={12} lg={2}>
                <TextField
                    type={"text"}
                    name={"numero"}
                    label={"Numero"}
                    mask={mascaras.numeroMask}
                    onChange={onChange}
                    value={filtro.numero}
                />
            </Col>
            <Col md={12} lg={2}>
                <TextField
                    type={"text"}
                    name={"bairro"}
                    label={"Bairro"}
                    onChange={onChange}
                    value={filtro.bairro}
                />
            </Col>
        </Row>
        <Row className='text-center align-items-center'>
            <Col md={12} lg={12}>
                <Button
                    className='fw-bold'
                    color='info text-light'
                    onClick={handleGerarRelatorio}
                >
                    Gerar Relatório
                </Button>
            </Col>
        </Row>
    </Card>;
}
